export default function CTASection() {
  return (
    <section id="formation" className="grid md:grid-cols-2 min-h-screen">
      {/* Partie gauche - Image avec texte */}
      <div className="relative bg-[#F7F0ED] min-h-[600px] md:min-h-screen flex items-end">
        <img 
          src="https://static.readdy.ai/image/972e8dcf8005bdff37194c729f906789/a5a0c9d8954ace2e2c052919cf87a5bd.jpeg"
          alt="Cavalière en harmonie avec son cheval"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
        
        <div className="relative z-10 p-12">
          <div className="text-xs font-light text-white/80 mb-4 tracking-wider">/rejoignez la formation</div>
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-extrabold text-white leading-tight" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            Reprenez<br />
            votre liberté<br />
            à cheval
          </h2>
        </div>
      </div>

      {/* Partie droite - Contenu CTA */}
      <div className="bg-white flex items-center justify-center p-12 md:p-16">
        <div className="max-w-lg w-full">
          <h3 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#1A1A1A] mb-6 text-center leading-tight">
            Formation<br />Endométriose<br />&amp; Équitation
          </h3>
          
          <p className="text-base md:text-lg text-[#6B6B6B] leading-relaxed text-center mb-8" style={{ lineHeight: '1.8' }}>
            Il est temps de ne plus laisser cette maladie décider à la place des cavalières. Cette formation existe pour leur permettre de reprendre leur liberté, leur corps, leur lien avec leur cheval et leur plein potentiel.
          </p>

          <div className="bg-[#FAF7F4] rounded-2xl p-8 mb-8">
            <h4 className="text-xl font-bold text-[#3D2817] mb-4">Cette formation vous permet de :</h4>
            <ul className="space-y-3">
              {[
                'Gérer la douleur pendant votre pratique',
                'Retrouver mobilité et fluidité à cheval',
                'Restaurer votre connexion avec votre cheval',
                'Reprendre confiance en votre corps',
                'Continuer votre passion sans limitation'
              ].map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-[#E8956F] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-[#3A3A3A]">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <button className="w-full md:w-4/5 mx-auto block py-5 bg-[#3D2817] text-white rounded-full text-base font-medium hover:bg-[#2C1810] transition-all shadow-lg hover:shadow-xl hover:-translate-y-0.5 whitespace-nowrap cursor-pointer">
            Accéder à la Formation <i className="ri-arrow-right-line ml-2"></i>
          </button>

          <p className="text-xs text-gray-400 text-center mt-6">
            Une véritable solution, attendue depuis longtemps
          </p>
        </div>
      </div>
    </section>
  );
}